import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";
import { SurveyPage } from "./SurveyPage";
import { UnauthorizedPage } from "./UnauthorizedPage";
import { NotFoundPage } from "./NotFoundPage";
import ApplicationLayout from "./ApplicationLayout";
import { FC, useMemo } from "react";
import { registerGlobal403Handler } from "am-tax-fe-core";
import { SubmissionPage } from "./SubmissionPage/SubmissionPage";

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<ApplicationLayout />}>
            <Route index element={<SurveyPage />} />
            <Route path="Submitted" element={<SubmissionPage />} />
            <Route path="Unauthorized" element={<UnauthorizedPage />} />
            <Route path="404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
        </Route>,
    ),
);

export const PageRoutes: FC = () => {
    useMemo(() => {
        registerGlobal403Handler(() => {
            router.navigate("/unauthorized");
        });
    }, []);

    return <RouterProvider router={router} />;
};
